import { UnauthorizedError } from '@/core/types/errors/http-error'
import { AxiosError } from 'axios'

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof AxiosError) {
    const data = error.response?.data as Record<string, unknown> | undefined

    if (data?.errors && Array.isArray(data.errors) && data.errors[0]) {
      return String(data.errors[0])
    }
    if (typeof data === 'string') {
      return data
    }

    if (typeof data?.message === 'string') {
      return data.message
    }

    return error.message
  }

  if (error instanceof UnauthorizedError || error instanceof Error) {
    return error.message
  }

  return ''
}
